import { useTranslations } from 'next-intl';
import { useSiteInfo } from '@silvertours/front-entities';
import { String } from '@silvertours/front-shared';
import {
  ContactWrapper,
  ContactTitle,
  ContactText,
  ContactNumber,
  ContactButton,
  PhoneNumberIcon,
} from './ErrorPage.styles';

const Contact = () => {
  const t = useTranslations('features.errorPage');
  const {
    settings: { phoneNumber, language },
    featureToggles,
  } = useSiteInfo();

  const formattedNumber = String.parsePhoneNumber(phoneNumber, language);

  return (
    <ContactWrapper>
      <ContactTitle>{t('contact.title')}</ContactTitle>
      <ContactText>{t('contact.text')}</ContactText>
      {featureToggles.hideInfoline ? (
        <ContactButton href={t('contact.link')}>
          {t('contact.linkText')}
        </ContactButton>
      ) : (
        <ContactNumber>
          <PhoneNumberIcon />
          {formattedNumber.national}
        </ContactNumber>
      )}
    </ContactWrapper>
  );
};

export { Contact };
